import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import queryString from "query-string";
import Chat from "./Chat/Chat";
import ProtectRoute from "./Chat/ProtectRoute";
import "./Components/NetworkDetector.css";
import CustomerRating from "./CustomerRating/CustomerRating";
import InAppCall from "./InAppCall/InAppCall";
import LiveChat from "./LiveChat/LiveChat";
import Error from "./Login/Error";
import Login from "./Login/Login";
import LoginInApp from "./Login/LoginInApp";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions";

const wtheme = createTheme({
  palette: {
    primary: {
      main: "#3F80FF",
    },
    secondary: {
      main: "#BA68C8",
    },
    warning: {
      main: "#FF9800",
    },
    success: {
      main: "#4CAF50",
    },
    ready: {
      main: "#00FF00", //green
    },
    acw: {
      main: "#ffe900", //yellow
    },
    aux: {
      main: "#FFA500", //orange
      contrastText: "#ffffff",
    },
    busy: {
      main: "#ff0000", //red
      contrastText: "#ffffff",
    },
    "not bound": {
      main: "#727272", //gray
      contrastText: "#ffffff",
    },
    loggedoff: {
      main: "#727272", //gray
      contrastText: "#ffffff",
    },
    offline: {
      main: "#727272", //gray
      contrastText: "#ffffff",
    },
  },
});

function App() {
  const [isOnline, setOnline] = useState("");

  useEffect(() => {
    window.addEventListener("load", handleConnectionChange);
    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);

    return () => {
      window.removeEventListener("load", handleConnectionChange);
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  const handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";

    if (condition === "online") {
      const webPing = setInterval(() => {
        // fetch(process.env.REACT_APP_API_URL, {
        fetch("//google.com", {
          mode: "no-cors",
        })
          .then((response) => {
            console.log("fetch response:", response);
            setOnline("");
            return clearInterval(webPing);
          })
          .catch((err) => {
            console.log("error connection:", err);
            setOnline("Failed");
          });
      }, 2000);

      return;
    }

    console.log("No connection");
    return setOnline("NoConn");
  };

  const params = queryString.parse(window.location.search);

  useEffect(() => {
    let sessionTabID = sessionStorage.getItem("tabId");

    if (!sessionTabID) {
      sessionStorage.setItem("tabId", Math.floor(Math.random() * 1000000));
    }

    const visibilitychange = () => {
      // setting localToken
      let localToken = localStorage.getItem("token");

      let pageCheck =
        window.location.pathname.includes("login") ||
        window.location.pathname.includes("in-app-call") ||
        window.location.pathname.includes("in-app-video-call") ||
        window.location.pathname.includes("livechat");

      // if no token (already logged out from other page) and not on login page , reload
      if (!document.hidden && !localToken && !pageCheck) {
        localStorage.setItem("bypassAntiRefresh", true);
        window.location.reload(false);
      }
    };

    window.addEventListener("visibilitychange", visibilitychange);

    return () => {
      localStorage.removeItem("tabId");
      window.removeEventListener("visibilitychange", visibilitychange);
    };
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {isOnline === "NoConn" ? (
        <div className="internet-error">
          <p>NO INTERNET CONNECTION</p>
        </div>
      ) : isOnline === "Failed" ? (
        <div className="internet-error">
          <p>FAIL TO CONNECT TO SERVER</p>
        </div>
      ) : (
        ""
      )}

      <ThemeProvider theme={wtheme}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectRoute>
                  <Chat />
                </ProtectRoute>
              }
            />

            <Route path="/customer-rating" element={<CustomerRating />} />
            <Route path="/error" element={<Error />} />
            <Route path="/inapp" element={<LoginInApp params={params} />} />
            <Route path="/livechat" element={<LiveChat />} />
            <Route path="/login" element={<Login />} />
            <Route path="/in-app-call" element={<InAppCall />} />
            <Route path="/in-app-video-call" element={<InAppCall videoCall />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
